var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResumeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1091 0.0499878C15.9152 0.0499878 16.6804 0.403973 17.2029 1.01776L20.8943 5.3537C21.3175 5.85107 21.5496 6.48284 21.5496 7.13593V21.2004C21.5493 22.719 20.3182 23.9504 18.7996 23.9504H5.19995C3.6813 23.9504 2.45016 22.719 2.44995 21.2004V2.79999C2.44995 1.2812 3.68117 0.0499879 5.19995 0.0499878H15.1091ZM5.19995 1.54999C4.50959 1.54999 3.94995 2.10963 3.94995 2.79999V21.2004C3.95016 21.8906 4.50973 22.4504 5.19995 22.4504H18.7996C19.4898 22.4504 20.0493 21.8906 20.0496 21.2004V7.13593C20.0496 6.83902 19.9442 6.55147 19.7517 6.32538L16.0613 1.98944C15.8238 1.71049 15.4755 1.54999 15.1091 1.54999H5.19995Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 8H14",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 13H17",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 18H17",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResumeIcon);
export default __webpack_public_path__ + "static/media/resume-icon.85db18ac75bdb7442bed03ab63991c52.svg";
export { ForwardRef as ReactComponent };